import React, {useState, useEffect, Fragment} from 'react';
import {Section, Popup, List, Loader, Explanation_text} from '../../../components';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';

export default function Blacklisted(props){
  const [blocked_prospects, setBlockedProspects]=useState(undefined);
  const [checkboxes, setCheckboxes]=useState([]);
  const [delete_checkboxes, setDeleteCheckboxes]=useState([]);


  useEffect(()=>{
    axios.get('/api/companies/blacklisted').then((data)=>{
      setBlockedProspects(data.data);
    })
  },[]);

  let black_list=[];
  let delete_list=[];
  if(blocked_prospects!=undefined && blocked_prospects!='loading'){
    for(let bp of blocked_prospects){
      if(bp.delete_and_block==true){
        black_list.push({id:bp.id, website:bp.website, main_text:bp.name, secondary_text:"Website: "+bp.website+" - City: "+bp.city});
      }else{
        delete_list.push({id:bp.id, website:bp.website, main_text:bp.name, secondary_text:"Website: "+bp.website+" - City: "+bp.city});
      }
    }
  }

  function restore(){
    axios.post('/api/companies/unblacklist', {unblacklist:delete_checkboxes}).then((data)=>{
      window.location.reload();
    });
  }


  function restoreFromBlacklist(){
    axios.post('/api/companies/unblacklist', {unblacklist:checkboxes}).then((data)=>{
      window.location.reload();
    });
  }
//  <Section>
//    <Typography style={{width:'100%', textAlign:'center', marginTop:'0px', marginBottom:'40px'}} color='secondary' variant='h5'>{delete_list.length+' '}<Explanation_text text='Deleted in the last month' inline/></Typography>
//      <Typography style={{marginBottom:'20px', textAlign:'center', width:'100%'}}><Explanation_text inline text='After 1 month these prospects and all data associated is wiped from our servers. Untill then you can restore them to your account.'/></Typography>
//      <div style={{height:'400px', width:'calc(100% + 40px)', marginLeft:'-20px', position:'relative'}}>
//            <List onClick={(d)=>{if(d.website!=undefined){window.open('https://'+d.website)}}} background_colour='rgba(255,255,255,1)' small_text list_data={delete_list} checkboxes={delete_checkboxes} onChange={(x)=>{setDeleteCheckboxes(x);}}/>
//      </div>
//      <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'40px'}}><Button variant='contained' color='secondary' onClick={()=>{restore();}}>Restore</Button></div>
//  </Section>

  return(
    <Fragment>
      <Section>
        <Typography style={{width:'100%', textAlign:'center', marginTop:'0px', marginBottom:'40px'}} color='secondary' variant='h5'>{black_list.length+' '}<Explanation_text text='blacklisted_prospects_title' inline/></Typography>
          <Typography style={{marginBottom:'20px', textAlign:'center', width:'100%'}}><Explanation_text inline text='blacklisted_prospects_explanation_text'/></Typography>
          <div style={{height:'400px', width:'calc(100% + 40px)', marginLeft:'-20px', position:'relative'}}>
                <List onClick={(d)=>{if(d.website!=undefined){window.open('https://'+d.website)}}} background_colour='rgba(255,255,255,1)' small_text list_data={black_list} checkboxes={checkboxes} onChange={(x)=>{setCheckboxes(x);}}/>
          </div>
          <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'40px'}}><Button variant='contained' color='secondary' onClick={()=>{restoreFromBlacklist();}}>Restore</Button></div>
      </Section>
    </Fragment>
  )
}
